export default __webpack_public_path__ + "static/media/focus-on-work.8e9e7316.svg";